// src/components/VirtualHeader.jsx
import React, { useState, useEffect } from 'react'
import { Link, useNavigate }         from 'react-router-dom'
import { useDispatch, useSelector }  from 'react-redux'
import { FaList, FaBolt }            from 'react-icons/fa'
import { AiFillShopping, AiOutlinePicture } from 'react-icons/ai'
import { fetchCredits }              from '../store/reducers/creditsSlice'
import { trackVirtualAction }        from '../store/reducers/customerVirtualActivitySlice'
import { trackProductAction }        from '../store/reducers/productVirtualActivitySlice'
import CreditsModal                  from './CreditsModal'

export default function VirtualHeader() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const userId   = useSelector(s => s.auth.userInfo.id)

  // counts & credits from Redux
  const card_product_count = useSelector(s => s.card.card_product_count)
  const assets             = useSelector(s => s.virtualSwap.assets)
  const credits            = useSelector(s => s.credits.remaining)

  // local UI state
  const [showSidebar, setShowSidebar]           = useState(false)
  const [showCreditsModal, setShowCreditsModal] = useState(false)

  // on mount, fetch the latest remaining credits
  useEffect(() => {
    dispatch(fetchCredits())
  }, [dispatch])

  return (
    <>
      <div className="fixed top-0 left-0 w-full z-50 bg-white shadow h-20">
        <div className="max-w-5xl mx-auto h-20 flex justify-between items-center px-4">
          {/* LEFT: hamburger + cart */}
          <div className="flex items-center gap-3">
            <div
              className="w-[30px] h-[30px] bg-white text-slate-700 rounded-sm cursor-pointer p-1.5 lg:hidden md:flex"
              onClick={() => {
                setShowSidebar(true)
                dispatch(trackVirtualAction({ userId, actionType: 'open_sidebar' }))
                dispatch(trackProductAction({ productId: null, actionType: 'open_sidebar' }))
              }}
            >
              <FaList className="text-xl" />
            </div>
            <div
              className="relative flex justify-center items-center cursor-pointer w-[35px] h-[35px] rounded-full bg-[#e2e2e2]"
              onClick={() => {
                dispatch(trackVirtualAction({ userId, actionType: 'view_cart' }))
                dispatch(trackProductAction({ productId: null, actionType: 'view_cart' }))
                navigate('/card')
              }}
            >
              <AiFillShopping className="text-xl text-orange-500" />
              {card_product_count > 0 && (
                <span className="absolute -top-[3px] -right-[5px] bg-green-500 text-white text-xs w-[18px] h-[18px] rounded-full flex items-center justify-center">
                  {card_product_count}
                </span>
              )}
            </div>
          </div>

          {/* CENTER: logo */}
          <div className="flex-1 flex justify-center">
            <Link to="/">
              <img
                src="/images/logo2.png"
                alt="TrendStreet"
                className="h-12 object-contain"
              />
            </Link>
          </div>

          {/* RIGHT: credits + gallery */}
          <div className="flex items-center gap-4">
            {/* Credits display */}
            <div
              className="relative cursor-pointer"
              onClick={() => {
                dispatch(trackVirtualAction({ userId, actionType: 'view_credits' }))
                dispatch(trackProductAction({ productId: null, actionType: 'view_credits' }))
                setShowCreditsModal(true)
              }}
            >
              <FaBolt size={24} className="text-yellow-500" />
              <span className="absolute -top-1 -right-2 bg-green-500 text-white text-xs w-[18px] h-[18px] rounded-full flex items-center justify-center">
                {credits}
              </span>
            </div>

            {/* Gallery icon */}
            <div
              className="relative cursor-pointer"
              onClick={() => {
                dispatch(trackVirtualAction({ userId, actionType: 'view_gallery' }))
                dispatch(trackProductAction({ productId: null, actionType: 'view_gallery' }))
                navigate('/fashnassets')
              }}
            >
              <AiOutlinePicture size={24} className="text-blue-600" />
              {assets.length > 0 && (
                <span className="absolute -top-1 -right-2 bg-green-500 text-white text-xs w-[18px] h-[18px] rounded-full flex items-center justify-center">
                  {assets.length}
                </span>
              )}
            </div>
          </div>
        </div>
        {/* spacer to push content below header */}
        <div style={{ height: '80px' }} />
      </div>

      {/* MOBILE SIDEBAR */}
      {showSidebar && (
        <div className="fixed inset-0 z-40 flex">
          <div
            className="w-64 bg-white h-full shadow-lg p-4"
            onClick={() => setShowSidebar(false)}
          >
            {/* sidebar content… */}
          </div>
          <div
            className="flex-1 bg-black bg-opacity-50"
            onClick={() => setShowSidebar(false)}
          />
        </div>
      )}

      {/* Credits modal */}
      {showCreditsModal && (
        <CreditsModal onClose={() => setShowCreditsModal(false)} />
      )}
    </>
  )
}
